import type { FeatureFlag } from '@/config/featureFlag'

export default function getOrderedActiveSearchType(config: FeatureFlag) {
  return config.activeSearchModesPriority.filter(
    (mode) =>
      config.activeSearchModes[
        (mode.charAt(0).toLowerCase() +
          mode.slice(1)) as keyof typeof config.activeSearchModes
      ]
  )
}
